
import 'keen-slider/keen-slider.min.css';
import KeenSlider from 'keen-slider';
import respUtility from '~/mixins/respUtility';

export default {
  name: 'ListingProductsListItemImagesSlider',
  mixins: [respUtility],
  props: {
    hoverGallery: {
      type: Array,
      default: () => [],
    },
    hoverItemDone2: {
      type: Boolean,
      default: false,
    },
    slugProduct: {
      type: String,
      default: '',
    },
    productId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      slider: null,
      current: 0,
      isAnimate: true,
      isFirstSlide: true,
      hoverState: {
        prev: false,
        next: false,
      },
    };
  },
  computed: {
    dotHelper() {
      return this.slider ? [...Array(this.slider?.track?.details?.slides?.length).keys()] : [];
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.initSliders();
    });
  },
  beforeDestroy() {
    if (this.slider) {
      this.slider?.destroy();
    }
  },
  methods: {
    initSliders() {
      this.slider = new KeenSlider(
        this.$refs.imagesSlider,
        {
          loop: true,
          drag: false,
          initial: this.current,
          slides: { spacing: 4 },
          defaultAnimation: { duration: 400 }, // must be the same value as on this line => animation-delay: 400ms;
          slideChanged: (s) => {
            this.current = s.track.details.rel;
          },
        },
        [
          (slider) => {
            let timeout;
            let clickEl = false;
            const clearNextTimeout = () => {
              clearTimeout(timeout);
            };
            const nextTimeout = () => {
              clearTimeout(timeout);
              if (clickEl) return;
              // for isFirstSlide must be the same value as on this line => animation-duration: 1000ms;
              // and for outhrers => animation-duration: 2000ms;
              const delay = this.isFirstSlide ? 1000 : 2000;
              timeout = setTimeout(() => {
                slider.next();
                this.isFirstSlide = false;
              }, delay);
            };
            slider.on('created', () => {
              setTimeout(() => {
                const clickDisabledAutoSwitch = this.$refs.imagesSliderWrap?.querySelectorAll('.clickDisabledAutoSwitch');
                if (clickDisabledAutoSwitch) {
                  clickDisabledAutoSwitch.forEach((click) => {
                    click.addEventListener('click', () => {
                      clickEl = true;
                      this.isAnimate = false;
                      clearNextTimeout();
                    });
                  });
                }
              }, 0);
              nextTimeout();
            });
            slider.on('dragStarted', clearNextTimeout);
            slider.on('animationEnded', nextTimeout);
            slider.on('updated', nextTimeout);
          },
        ],
      );
    },
  },
};
